// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"199":"4a729de8","345":"62421a86","511":"cc32b7b0","526":"c4e9381a","615":"c69079f8","677":"4bfa147e","925":"ab4b5526","945":"4fd548b3","954":"b501d5a0"}[chunkId] + ".chunk.js";
};